import Vue from 'vue';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import '@babel/polyfill';
import './toasts';
import VueMoment from 'vue-moment';
import moment from 'moment';
import './assets/index.css';
// Add a build timestamp for cache busting
Vue.prototype.$buildVersion = process.env.NODE_ENV === 'production'
    ? `v=${process.env.CACHE_BUSTER || new Date().getTime()}`
    : 'dev';
// Add a method to append version to URLs for cache busting
Vue.prototype.$withVersion = function (url) {
    if (!url)
        return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${this.$buildVersion}`;
};
Vue.use(VueMoment, {
    moment
});
Vue.config.productionTip = false;
new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
